<template>
    <div v-if="!noticeAcknowledged && message && message.length > 0" style="background-color: lightgrey;" class="d-flex">
        <div class="col pb-2 px-3 d-flex flex-column">
            <h4 class="m-0">Notice</h4>
            <span>{{ message }}</span>
        </div>
        <div class="p-3 d-flex">
            <Button label="Close" icon="pi pi-times" iconPos="left" @click="acknowledgeNotice" />
        </div>
    </div>
</template>

<script lang="ts">
	import noticemessageApi from "@/api/noticemessage-api";
    import { defineComponent } from "vue";

	export default defineComponent({
		data() {
			return {
				message: "",
			};
		},
        computed: {
            noticeAcknowledged() {
                return this.$store.getters.getNoticeAcknowledged;
            },
        },
        mounted() {
            noticemessageApi.noticeMessageGet(null).then(
                response => {
                    this.message = response.data;
                }
            )
        },
        methods: {
            acknowledgeNotice() {
                this.$store.dispatch('setNoticeAcknowledged', true);
            },
        }
	});
</script>